var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "interconnection"
  }, [_c('div', {
    staticClass: "department"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('Input', {
    attrs: {
      "search": "",
      "placeholder": $t("d5d2ku4", "搜索成员"),
      "clearable": ""
    },
    on: {
      "on-search": _vm.onSearchList
    },
    model: {
      value: _vm.search.value,
      callback: function ($$v) {
        _vm.$set(_vm.search, "value", $$v);
      },
      expression: "search.value"
    }
  }), _c('Icon', {
    staticClass: "icon",
    attrs: {
      "type": "md-add"
    },
    on: {
      "click": function ($event) {
        return _vm.openModal('add');
      }
    }
  })], 1), _c('STree', {
    ref: "STree",
    attrs: {
      "org": _vm.org
    },
    on: {
      "clear": _vm.clearSearchValue
    }
  })], 1), _c('div', {
    staticClass: "list"
  }, [_c('List', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showList,
      expression: "showList"
    }],
    on: {
      "detail": _vm.changeDetail
    }
  }), _c('Detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showUserDetail,
      expression: "showUserDetail"
    }],
    on: {
      "cancel": function ($event) {
        return _vm.changeAction('1');
      }
    }
  })], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };